import React from "react";

/** Renders normalized Serper hits (organic or news) in the same card layout as sweep results. */
export default function SerperOrganicHitList({ hits = [], emptyMessage = "No Serper results." }) {
  if (!hits.length) {
    return <p className="text-xs text-muted-foreground px-1 py-2">{emptyMessage}</p>;
  }
  return (
    <div className="divide-y divide-border/60 border border-border rounded-md overflow-hidden bg-card/20">
      {hits.map((r, i) => (
        <div key={`${r.link || "row"}-${i}`} className="px-3 py-2.5 space-y-1.5">
          <div className="flex items-start gap-2">
            {r.position != null && (
              <span className="shrink-0 text-[10px] font-mono tabular-nums px-1.5 py-0.5 rounded bg-muted text-muted-foreground mt-0.5">
                #{r.position}
              </span>
            )}
            <a
              href={r.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-medium text-primary hover:underline flex-1 leading-snug"
            >
              {r.title || "Untitled"}
            </a>
          </div>
          <div className="text-[10px] text-muted-foreground pl-0 sm:pl-8">{r.displayLink || "—"}</div>
          {(r.publisher || r.news_date) && (
            <div className="text-[10px] text-muted-foreground/90 pl-0 sm:pl-8 flex flex-wrap gap-x-2 gap-y-0.5">
              {r.publisher ? <span>{r.publisher}</span> : null}
              {r.news_date ? (
                <span className="tabular-nums">{r.publisher ? `· ${r.news_date}` : r.news_date}</span>
              ) : null}
            </div>
          )}
          {r.snippet && (
            <p className="text-xs text-muted-foreground leading-relaxed line-clamp-3 pl-0 sm:pl-8">{r.snippet}</p>
          )}
        </div>
      ))}
    </div>
  );
}
